import { controller } from './gdpr-consent.controller';
import { id } from './gdpr-consent.component.html';
import './gdpr-consent.scss';


angular.module('BB').component('gdprConsent', {
    bindings: {
        consent: '=',
        hasError: '<',
        isAdmin: '<'
    },
    controller,
    templateUrl: id
});



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/gdpr-consent/gdpr-consent.component.js